import { render } from "./GetPrices.vue?vue&type=template&id=88e9cc1c&scoped=true"
import script from "./GetPrices.vue?vue&type=script&lang=js"
export * from "./GetPrices.vue?vue&type=script&lang=js"

import "./GetPrices.vue?vue&type=style&index=0&id=88e9cc1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88e9cc1c"]])

export default __exports__